import React, { useEffect } from "react";
import styled from "styled-components";
import h5Share from '@/utils/h5Share'
import OpenApp from '@/components/OpenApp'
// 示例用法

const App = () => {
  useEffect(() => {
    document.title = '市值风云十周年活动';
      const data = { 
      title: `市值风云十周年庆活动进行中！`,
      desc: '会员买一送一，上祝福墙，还能领十周年纪念周边！', 
      link: window.location.href,
      imgUrl:  'https://file.wogoo.com/app/logo/logo210.jpg',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo210.jpg'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo210.jpg'
      }
    }
    h5Share.main(data)
  },[])
  return (
    <Content>
        <img className="bg" src={require('./images/十周年_2@2x.png')} alt="share" />
         <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_210/code`}></OpenApp>
    </Content>
    
  )
}


export default App;

const Content = styled.div`
  width: 100%;
  min-height: calc(100vh);
  border-radius: 0px 0px 0px 0px;
  background-color: #a2060d;
  .bg {
    width: 100vw;
    height: 100vh;
    use-select: none;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_210/share.js